export type FacesheetVersion = 'UNKNOWN' | 'FS1' | 'FS2';

export interface FacesheetImage {
  id: string;
  signedUrl?: string;
  createdAt?: string | Date;
}

export interface Facesheet {
  id: string;
  facesheetRequestId?: string;
  name: string;
  uploadedAt: string | Date;
  requestedAt?: string | Date;
  requestedByName?: string;
  requestedByEmail?: string;
  version: FacesheetVersion;
  resultsSummaries: FacesheetImage[];
  sources: FacesheetImage[];
}

export const getFacesheetVersion = (
  facesheet: Pick<Facesheet, 'version'>,
): FacesheetVersion => facesheet.version;

export const isFs2Facesheet = (
  facesheet: Pick<Facesheet, 'version'>,
): boolean => getFacesheetVersion(facesheet) === 'FS2';

export interface ViewFacesheetSummaryParams {
  facesheetRequestId: string;
  facesheetName?: string;
}
